import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import TimelineList from '@shared/components/timelines/timeline-list/timeline-list.vue';
import TimelineItem from '@shared/components/timelines/timeline-item/timeline-item.vue';
import ActivityChanges from '@tools/components/activity-changes/activity-changes.vue';
import TableHeader from '@shared/components/tables/table-header/table-header.vue';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import ActivityShortInfo from '@tools/components/activity-short-info/activity-short-info.vue';
import ActivityBookingShortInfo from '@tools/components/activity-booking-short-info/activity-booking-short-info.vue';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import { ActivityLog } from '@tools/interfaces/activity-log';
library.add(faPlus);

@Component({
  name: 'bpc-entity-table-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-timeline-list': TimelineList,
    'bpc-timeline-item': TimelineItem,
    'bpc-activity-changes': ActivityChanges,
    'bpc-table-header': TableHeader,
    'bpc-table-footer': TableFooter,
    'bpc-std-filter': StdFilter,
    'bpc-activity-short-info': ActivityShortInfo,
    'bpc-activity-booking-short-info': ActivityBookingShortInfo,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class ActivityLogTimelineInput extends mixins(AbstractField, AbstractTable) {
  public entity: ActivityLog = null;
  public entityName = 'activity-log';
  public pluralEntityName = 'activity-logs';

  //public ignoreURLParams = true;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
  ];

  public customPageActions = {};
  public customRowActions = {};

  constructor() {
    super();
  }

  getVariant(item): string {
    if (item.description === 'updated') {
      return 'warning';
    } else if (item.description === 'soft-deleted') {
      return 'danger';
    } else if (item.description === 'deleted') {
      return 'danger';
    } else if (item.description === 'created') {
      return 'success';
    }
  }
}
